<div class="mx-auto surface-section lg:px-5 px-3 py-3 border-round-lg">
  <upload-contract>
    <ng-container>
<!--      <div class="flex justify-content-center mb-5">-->
<!--      <span class="w-6rem h-6rem border-circle flex justify-content-center align-items-center bg-cyan-100">-->
<!--        <i class="pi pi-file text-cyan-600 text-5xl"></i>-->
<!--      </span>-->
<!--      </div>-->
      <div class="text-center mb-6 mt-5">
        <div class="text-900 text-3xl font-semibold mb-2">Weitere Verträge</div>
        <span class="text-600 font-medium line-height-3 text-color-secondary">Hier kannst du uns weitere Verträge für die Verwaltung über Klaus versichert mitteilen.</span>
       <div class="hidden lg:block">
         <button pButton label="QR Scan for phone upload" class="mt-2" (click)="handleQRDialog()"></button>
       </div>
      </div>
    </ng-container>
  </upload-contract>
</div>

<p-dialog [modal]="true" [(visible)]="qrDialog" header="QRScaner" [style]="{width: '50rem', height: '50rem'}">
  <div class="flex justify-content-center">
    <app-pdf-view *ngIf="base64" [base64]="base64"></app-pdf-view>
  </div>
</p-dialog>
